import React from 'react';
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import Listing from "../Components/JobListing/Listing";
import Filter from "../Components/JobListing/Filters";
import { UserContext } from "../Providers/UserProvider";
import { useContext } from "react";
import '../Styles/Sass/FindJob.scss';

function FindAJob() {
  const [jobFilter, setJobFilter] = React.useState({
    areaOfWork: [],
    requiredServices: [],
    availability: [],
    numberOfWorkers: 0,
    supplies: false,
    equipment: false,
    rate: 150
  });
  const [triggerUpdate, setTriggerUpdate] = React.useState(false);

  const user = useContext(UserContext);

  const setFilter = (filter, value) => {
    let currentFilter = jobFilter;
    if (filter === 'supplies') {
      currentFilter.supplies = !currentFilter.supplies;
    } else if (filter === 'equipment') {
      currentFilter.equipment = !currentFilter.equipment;
    } else if (filter === 'numberOfWorkers' || filter === 'rate') {
      currentFilter[filter] = value;
    } else {
      let indexOfValue = currentFilter[filter].findIndex(filterValue => {
        return value === filterValue;
      });
      if (indexOfValue === -1) {
        currentFilter[filter].push(value);
      } else {
        currentFilter[filter].splice(indexOfValue, 1);
      }
    }
    setJobFilter(currentFilter);
    setTriggerUpdate(!triggerUpdate);
  }

  return (
    <section className='findJob'>
      <Navbar/>
      {
        user === null ?
        <>
          <h3 >If you would like to see any listings, please sign up</h3>
        </> :
        <>
          <div className="findJob__banner">
            <h1>Find a Job</h1>
          </div>
          <div className='findJob__postBox'>
            <Filter
              jobFilter={jobFilter}
              setFilter={setFilter}
            />
            <Listing
              user={user}
              jobFilter={jobFilter}
              triggerUpdate={triggerUpdate}
              page={'findJob'}
            />
          </div>
        </>
      }
      <Footer/>
    </section>
  );
}

export default FindAJob;
